import React                            from 'react';
import { Observe }                      from 'rewire-core';
import Grid                             from '../ui/Grid';
import { defaultFontSizes }             from './TimecardGrids';
import AccordionView, { useGridStyles } from './AccordionView';
import timeclocksModel, {
  TimeclocksModel
} from './TimeclocksModel';

interface ITimeclocksProps {
  model: TimeclocksModel;
}

const TimeclocksView = (props: ITimeclocksProps) => {
  const styles = useGridStyles(props);
  return <Observe>{() => (
    (!timeclocksModel.visible)
    ? null
    : <AccordionView model={timeclocksModel} title='Timeclocks'>
        <Observe render={() => {
          return <Grid grid={timeclocksModel.grid} className={styles.grid} gridFontSizes={defaultFontSizes} />;
        }} />

      </AccordionView>
  )}</Observe>;
};

export default TimeclocksView;